<template>
  <v-row :style="{ height: '80%' }">
    <v-flex />
    <v-card :style="{ width: '75%', 'margin-top': '20px' }">
      <v-toolbar color="secondary">
        <v-card-title class="white--text">{{ c_loginLabel }}</v-card-title>
      </v-toolbar>
      <v-card-text class="cardTextHeight">
        <v-form ref="form">
          <v-row pr-4 align="center">
            <v-flex xs3> </v-flex>
            <v-flex xs8>
              <v-text-field
                v-model="email"
                :placeholder="c_usernameLabel"
                filled
                outlined
                :label="c_usernameLabel"
                :rules="rules"
                ref="email"
              ></v-text-field>
            </v-flex>
            <v-flex xs1> </v-flex>
            <v-flex xs3> </v-flex>
            <v-flex xs8>
              <v-text-field
                v-model="password"
                :placeholder="c_passwordLabel"
                filled
                outlined
                :label="c_passwordLabel"
                :rules="rules"
                type="password"
                v-on:keyup.enter="login"
              ></v-text-field>
            </v-flex>
            <v-flex xs1> </v-flex>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="mx-5">
        <v-spacer /><v-btn @click.stop.prevent="login">Submit</v-btn>
      </v-card-actions>
    </v-card>
    <v-flex />
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      email: undefined,
      password: undefined,
      user_id: undefined,
      rules: [
        (x) => {
          if (!x) {
            return "This Field Is Required";
          }
          return true;
        },
      ],
    };
  },
  computed: {
    c_loginLabel() {
      return this.$store.getters["getLabelByKey"]("login", this.c_language);
    },
    c_usernameLabel() {
      return this.$store.getters["getLabelByKey"]("username", this.c_language);
    },
    c_passwordLabel() {
      return this.$store.getters["getLabelByKey"]("password", this.c_language);
    },
    c_language() {
      return this.$store.getters["primaryLanguage"];
    },
  },
  methods: {
    async login() {
      const { data } = await this.$axios({
        method: "post",
        url: "/company/login",
        data: { email: this.email, password: this.password },
      });
      if (data.success) {
        window.localStorage.setItem(
          "easy1",
          JSON.stringify({
            Authorization: data.data.access_token,
            user_id: data.data.companyId,
            company: data.data.company,
          })
        );
        this.$store.dispatch("setUserId", data.data.companyId);
        this.$store.dispatch("setToken", data.data.access_token);
        this.$store.dispatch("setCompany", data.data.company);
      }
    },
  },
};
</script>
